import { useFirebaseValue } from "@pathwright/web/src/modules/firebase/utils"

const useCanSyncPath = ({ path }) => {
  let pathPublishPath = null
  if (path && path.user) {
    pathPublishPath = `/path/${path.sync.sync_source_path_id}/publish/`
  }

  const [pathPublish] = useFirebaseValue(pathPublishPath)

  // can the user sync their path with its sync source path (new updates available)
  let canSync = false

  if (path && pathPublish && pathPublish.lastPublishedDateTime) {
    const lastPublishedToTime = new Date(
      pathPublish.lastPublishedDateTime
    ).getTime()
    const lastSyncedTime = new Date(
      path.sync.last_synced_date || path.created_date
    ).getTime()
    canSync = lastPublishedToTime > lastSyncedTime
  }

  return canSync
}

export default useCanSyncPath
